import { render, staticRenderFns } from "./majorScore.vue?vue&type=template&id=e8a856f0&scoped=true&"
import script from "./majorScore.vue?vue&type=script&lang=js&"
export * from "./majorScore.vue?vue&type=script&lang=js&"
import style0 from "./majorScore.vue?vue&type=style&index=0&id=e8a856f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a856f0",
  null
  
)

export default component.exports